// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.au-tr {
  transition: background var(--admin-transition-fast);
}

.au-tr td {
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.au-tr:hover {
  background: var(--admin-bg-hover);
}

.au-tr.is-clickable {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/ui/AdminTr.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".au-tr {\n  transition: background var(--admin-transition-fast);\n}\n\n.au-tr td {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n}\n\n.au-tr:hover {\n  background: var(--admin-bg-hover);\n}\n\n.au-tr.is-clickable {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
